import React, { useState, useEffect, useRef } from "react";
import Listing from "../../../../assets/components/listing/Listing";
import { TransitionGroup } from "react-transition-group";
import Eyeicon from "../../../../assets/images/eye_icon.png";
import ResizeDetector from "react-resize-detector";
import AlertModal from "../../../../assets/components/modal/AlertModal";
import { delSurveyReply, getAllPostParticipants } from '../../../../actions/activities_reply_actions';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert";
import Loader from "react-loaders";
import LoadingOverlay from "react-loading-overlay-ts";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";

const GeneralForumParticipants = (props) => {
  const searchString = props.searchedParticipant;
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [searchParams] = useSearchParams();
  const urlPage = parseInt(searchParams.get("page")) || 1;
  const isInitialMount = useRef(true);

  const activityParticipantState = useSelector(
    (state) => state.ActivityParticipant,
  );

  const [isLoading, setLoading] = useState(true);
  const [delId, setDelID] = useState();
  const [participantData, setParticipantData] = useState([]);
  const [isModalOpen, setModal] = useState(false);

  const [participantColumn, setParticipantColumn] = useState([
    { Name: 'Respondent Name', Type: 'Object', key: 'author.userName' },
    { Name: "Respondent Email", Type: 'Object', key: 'author.email', width: 280 },
    { Name: "Phone No", Type: 'Object', key: 'author.phone', width: 220 },
    {
      Name: "Action",
      Type: 'action',
      options: [
        {
          icon: Eyeicon,
          url: "/admin/participant-post-activity/" + params.activityid,
          type: 'button',
          idObjectName: 'author'
        },
      ]
    }
  ]);

  const showModal = () => {
    setDelID();
    setModal(!isModalOpen);
  };

  const getPostParticipants = (
    page = urlPage,
    limit = activityParticipantState.dataLimit || 5,
    searched = searchString,
  ) => {
    setLoading(true);
    dispatch(
      getAllPostParticipants({
        page: page,
        limit: limit,
        activityId: params.activityid,
        search: searched,
      }),
    )
      .then((response) => {
        setParticipantData(response.payload.content.participants);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.data.name !== "Not Found") {
          Swal({
            title: err.response ? err.response.data.name : "Error",
            text: err.response ? err.response.data.content : "Something went wrong",
            icon: "error",
          });
        }
      });
  };

  useEffect(() => {
    if (isInitialMount.current) {
      getPostParticipants(urlPage);
      isInitialMount.current = false;
    } else {
      navigate(`?page=1`, { replace: true });
      getPostParticipants(1);
    }
  }, [searchString]);

  useEffect(() => {
    if (!isInitialMount.current) {
      getPostParticipants(urlPage);
    }
  }, [urlPage]);

  useEffect(() => {
    delId ? setModal(true) : setModal(false);
  }, [delId]);

  const delResponse = () => {
    dispatch(delSurveyReply(delId))
      .then(() => {
        setDelID();
        getPostParticipants(urlPage);
        Swal({ title: "Deleted", text: "Response Deleted", icon: "success" });
      })
      .catch((err) => {
        setDelID();
        Swal({
          title: "Error",
          text: err.response ? err.response.data.content : "Something went wrong",
          icon: "error",
        });
      });
  };

  return (
    <TransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear={true}
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      <ResizeDetector
        handleWidth
        render={({ width }) => (
          <>
            <AlertModal
              isModalOpen={isModalOpen}
              setModal={showModal}
              onClick={delResponse}
            />

            <LoadingOverlay
              tag="div"
              active={isLoading}
              styles={{
                overlay: (base) => ({
                  ...base,
                  background: "#fff",
                  opacity: 0.5,
                }),
              }}
              spinner={<Loader color="#6c757d" active type="ball-pulse" />}
            >
              <div className="table_border">
                <Listing
                  columnName={participantColumn}
                  data={participantData}
                  currentPage={urlPage}
                  totalPages={activityParticipantState.totalPages || 1}
                  dataLimit={activityParticipantState.dataLimit || 5}
                  getListingData={(page) => {
                    navigate(`?page=${page}`, { replace: true });
                  }}
                  startLoading={() => setLoading(true)}
                />
              </div>
            </LoadingOverlay>
          </>
        )}
      />
    </TransitionGroup>
  );
};

export default GeneralForumParticipants;